"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspection = void 0;
exports.inspection = function (axios) {
    return {
        getInspectionsReject: function (_a) {
            var mallProductNo = _a.params.mallProductNo;
            return axios.get("/inspections/" + mallProductNo + "/reject");
        },
        getProductsHistories: function (_a) {
            var mallProductNo = _a.params.mallProductNo;
            return axios.get("/products/" + mallProductNo + "/histories");
        },
        getProductsHistoriesV2: function (_a) {
            var mallProductNo = _a.params.mallProductNo;
            return axios.get("/products/" + mallProductNo + "/histories");
        }
    };
};
